import { Joyride, STATUS } from "react-joyride";

const LOCALE = {
  back: "Précédent",
  close: "Fermer",
  last: "Terminer",
  next: "Suivant",
  nextWithProgress: "Suivant ({current}/{total})",
  skip: "Passer",
};

export default function GuidedTour({ steps, run, onFinish }) {
  const handleEvent = (data) => {
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(data.status)) {
      onFinish?.();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      scrollToFirstStep
      onEvent={handleEvent}
      locale={LOCALE}
      options={{
        primaryColor: "hsl(260, 54%, 45%)",
        zIndex: 10000,
        showProgress: true,
        skipBeacon: true,
        scrollOffset: 100,
        targetWaitTimeout: 5000,
        buttons: ["back", "close", "skip", "primary"],
      }}
      styles={{
        tooltipTitle: { fontWeight: 700 },
      }}
    />
  );
}
